import styled from "styled-components";

/* Title and, under it, the options sized like the color cards (inside the Texto group's card) */
export const Container = styled.div<{ $locked?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  .title {
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }

  .plus {
    display: flex;
  }
`;

/* Same grid as the color cards: each option takes one card's width */
export const AlignOptionsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 16px;
`;

type AlignOptionContainerProps = {
  $active: boolean;
  $align: "CENTER" | "LEFT" | "RIGHT";
};

/* The lines sit where the Keepo's content would: on the left, centered or on the right */
export const AlignOptionContainer = styled.button<AlignOptionContainerProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: ${props => ({ LEFT: "flex-start", CENTER: "center", RIGHT: "flex-end" })[props.$align]};
  justify-content: center;
  height: 48px;
  padding: 0 16px;
  cursor: pointer;
  /* lighter than the card it sits on, as the other options */
  background-color: var(--color-neutral-base);
  border: 2px solid ${props => (props.$active ? "var(--color-brand-blue)" : "transparent")};
  border-radius: 12px;
  box-sizing: border-box;
  transition: border-color 0.15s;

  &:hover {
    border-color: ${props => (props.$active ? "var(--color-brand-blue)" : "var(--color-neutral-base)")};
  }

  span {
    display: inline-block;
    width: 20px;
    height: 3px;
    margin: 2px 0;
    background: var(--color-neutral-white);
    border-radius: 4px;

    &:nth-child(3) {
      width: 10px;
    }
  }
`;
